module.exports = __webpack_public_path__ + "4db87a1020cece40a294e3fc2724ffd2.jpg";